import { Component } from '@angular/core';
import { Router, RouterHashLocationFeature } from '@angular/router';
import { CmsComponentData } from '@spartacus/storefront';
import { CookieService } from 'ngx-cookie-service';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { AuthService, CmsService } from '@spartacus/core';
 
@Component({
  selector: 'app-uk-splash-page',
  templateUrl: './uk-splash-page.component.html',
  styleUrls: ['./uk-splash-page.component.scss'],
  standalone: false
})
export class UkSplashPageComponent {
  ukSplashPageData: any;
  currUrl!: string | null;
  pageLastUrl = '';
  loggedIn:boolean=false;
  webEnabled:boolean | undefined=false;
 
 
  constructor(
    private cookieService: CookieService,
    private router: Router,
    private component: CmsComponentData<any>,
    private userInfoService: UserInfoService,
    private cmsService: CmsService,
    private authService: AuthService
  ) {
 
  }
 
  ngOnInit() {
    this.component.data$.subscribe(data => {
      this.ukSplashPageData = data;
    })
 
    this.authService.isUserLoggedIn().subscribe((isLoggedIn: any) => {
      this.loggedIn=isLoggedIn;
 
      if(this.loggedIn){
        this.userInfoService.getUserData().subscribe(userData => {
          this.webEnabled=userData?.webEnabled
        })
      }
    });
  }
 
 
  // updateCookie(){
  //   const visitorType = this.cookieService.get('visitor_type');
  //   if (!visitorType || visitorType !== 'healthcare') {
  //     const inSixtyMinutes = new Date(new Date().getTime() + 60 * 60 * 1000);
  //     this.cookieService.set('visitor_type', 'healthcare', inSixtyMinutes, '/', '', true, 'None');
  //     if(sessionStorage.getItem('navigateToUrl') && sessionStorage.getItem('navigateToUrl') != ''){
  //       this.currUrl = sessionStorage.getItem('navigateToUrl')??'/';
  //       this.router.navigateByUrl(this.currUrl)
  //     }
  //     else{
  //       this.router.navigate(['/homepage']);
  //     }
  //   }
  // }
 
  // publicCookie(){
  //   const visitorType = this.cookieService.get('visitor_type');
  //   if (!visitorType || visitorType !== 'healthcare') {
  //     const inSixtyMinutes = new Date(new Date().getTime() + 60 * 60 * 1000);
  //     this.cookieService.set('visitor_type', 'healthcare', inSixtyMinutes, '/', '', true, 'None');
 
  //   }
  //     this.router.navigateByUrl(this.ukSplashPageData?.urlLink);
  // }
 
 
  /**
   * Clears CacheStorage caches created for this origin.
   *
   * This does NOT clear:
   * - Cookies
   * - localStorage
   * - sessionStorage
   *
   * This keeps the existing Spartacus / CDC / visitor logic intact.
   */
  private async clearBrowserCache(): Promise<void> {
    try {
      if (typeof window !== 'undefined' && 'caches' in window) {
        const cacheNames = await window.caches.keys();
 
        await Promise.all(
          cacheNames.map(cacheName => window.caches.delete(cacheName))
        );
 
        console.log('Browser CacheStorage cleared successfully');
      }
    } catch (error) {
      // Cache failure should never block the existing navigation/login flow.
      console.error('Unable to clear browser CacheStorage:', error);
    }
  }
 
 
  async updateCookie() {
    await this.clearBrowserCache();
 
    this.userInfoService.requestVisitorUpdate();
  }
 
 
  async publicCookie() {
    await this.clearBrowserCache();
 
    this.userInfoService.requestVisitorPublic(
      this.ukSplashPageData?.urlLink
    );
  }
 
}